import React from 'react'
import PropTypes from 'prop-types'
import withStyle, { StyledButton, StyledCustomText } from './ActionBar.style.js'

const ActionBar = ({ buttons, className }) => {
  const renderButton = (
    {
      text,
      action,
      type,
      disabled,
      loading,
      dataTestId,
      className: btnClassName = '',
    },
    index
  ) => {
    if (type === 'custom') return <StyledCustomText>{text}</StyledCustomText>
    return (
      <StyledButton
        key={action.toString()}
        type={type}
        onClick={action}
        loading={loading}
        disabled={disabled}
        index={index}
        dataTestId={dataTestId}
        className={btnClassName}
      >
        {text}
      </StyledButton>
    )
  }

  return <div className={className}>{buttons.map(renderButton)}</div>
}

ActionBar.propTypes = {
  className: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
      type: PropTypes.string,
      disabled: PropTypes.bool,
      loading: PropTypes.bool,
      dataTestId: PropTypes.string,
    })
  ),
}

ActionBar.defaultProps = {
  buttons: [],
}

export default withStyle(ActionBar)
